import Vue from 'vue';
import Vuex from 'vuex';
import {firebase} from './main';
Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        signedInFirebase: false,
        signedInLoginNew: false,
        categories: {

        },
        apps: {
            loading: {loading: true}
        },
        inapp: {
            update: 0,
            inited: false,
            isApp: false
        },
        appVersion: 0,
        customerGroups: [],
        online: true
    },
    getters: {
        isSignedIn: state => {
            return state.signedInLoginNew && state.signedInFirebase
        }
    },
    mutations: {
        setNEWAppProperties(state) {
            state.inapp.isApp = true;
            Vue.nextTick(() => {
                state.inapp.inited = true;
                state.inapp.update++;
            })
        },
        addApp(state, appId) {
            if(!state.apps.hasOwnProperty(appId)) {
                Vue.set(state.apps, appId, {loading: true});
                firebase.firestore().collection("apps").doc(appId).get().then(appDoc => {
                    if(appDoc.exists) {
                        /*if(!state.categories.hasOwnProperty(appDoc.data().category)) {
                            Vue.set(state.categories, appDoc.data().category, {
                                name: "...",
                                blank: true
                            });
                            firebase.firestore().collection("categories").doc(appDoc.data().category).get().then(catDoc => {
                                if(catDoc.exists) {
                                    Vue.set(state.categories, catDoc.id, catDoc.data());
                                }else{
                                    console.warn("Error loading category " + catDoc.id + ": Not found");
                                }
                            }).catch(error => {
                                console.warn("Error loading category " + appDoc.data().category + ":");
                                console.error(error);
                            });
                        }*/
                        Vue.set(state.apps, appId, appDoc.data());
                        state.appVersion++;
                    }else{
                        console.warn("Error loading app " + appId + ": Not found");
                    }
                }).catch(error => {
                    console.warn("Error loading app " + appId + ":");
                    console.error(error);
                });
            }
        },
        setCustomerGroups(state, groups) {
            groups[groups.length] = "all";
            state.customerGroups = groups;
        },
        signInFirebase(state, signInState) {
            state.signedInFirebase = signInState;
        },
        signInLoginNew(state, signInState){
            state.signedInLoginNew = signInState;
        }
    }
});

export default store;